import React, { useState } from 'react';
import { motion, AnimatePresence } from "framer-motion";

//utils
import { CloseBtn, Triangle } from '../../utils/svgIcons';


function Accordion({ children, isMobile }) {
    //if re-renders page in reponsive or adaptive
    // const [expanded, setExpanded] = useState(isMobile ? false : true);
    const [expanded, setExpanded] = useState(true);
    
    return (
        <div className={'accordion'}>
            {isMobile &&
                <div className={'accordion_head'}>
                    <div className={'accordion_title'}
                        onClick={() => setExpanded(true)}>
                        Categories
                      {expanded ? <Triangle /> : <div className={'rotate-180'}><Triangle /></div> }
                    </div>
                    <div className={`accordion_btn-close ${expanded ? 'fadeIn' : ''}`}
                        onClick={() => setExpanded(false)}>
                        <CloseBtn />
                    </div>
                </div>
            }

            <AnimatePresence initial={false}>
                {isMobile ?
                    expanded && (
                        <motion.div
                            className={'accordion_body'}
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            variants={{
                                open: { opacity: 1, height: "auto", scale: 1 },
                                collapsed: { opacity: 0, height: 0, scale: 0.9 }
                            }}
                            transition={{ duration: 0.55 }}>

                            {children}

                        </motion.div>)
                    :
                    <div className={'accordion_body'}>
                        {children}
                    </div>
                }
            </AnimatePresence>
        </div>
    );
}

export default Accordion;
